import { render, staticRenderFns } from "./VIPReservation.vue?vue&type=template&id=916ce2ae"
import script from "./VIPReservation.vue?vue&type=script&lang=js"
export * from "./VIPReservation.vue?vue&type=script&lang=js"
import style0 from "./VIPReservation.vue?vue&type=style&index=0&id=916ce2ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports